// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5auoX","type":"styles_type__2Nmon","choices":"styles_choices__2hZeB"};